// extracted by mini-css-extract-plugin
export var wrapper = "PageHome-module--wrapper--39De0";
export var title = "PageHome-module--title--2BCuR";